import { useParams } from 'react-router-dom';

export function useProjectIds() {
    const params = useParams();
    const projectId = params?.projectId ? parseInt(params.projectId, 10) : undefined;
    const subprojectId = params?.subprojectId ? parseInt(params.subprojectId, 10) : undefined;
    return { projectId, subprojectId };
}
